/**
 * Current time in milliseconds.
 * Usually since system-start, but not during tests.
 */
export function now() {
    return (typeof performance === "object" ? performance : Date).now();
}
